module.exports = __webpack_public_path__ + "img/maintenance-icon.dd86755b.svg";